import { render, staticRenderFns } from "./official-account.vue?vue&type=template&id=d143db50&scoped=true&"
import script from "./official-account.vue?vue&type=script&lang=js&"
export * from "./official-account.vue?vue&type=script&lang=js&"
import style0 from "./official-account.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./official-account.vue?vue&type=style&index=1&id=d143db50&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d143db50",
  null
  
)

export default component.exports